import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import PageNotFound from "../../../../Component/NotFound/index";
import AttendanceLog from "./AttendanceLog";
import Device from "./Device";
import ExtraTime from "./ExtraTime";
import Policy from "./Policy";
import RequestCycle from "./RequestCycle";
import ConfigureCycle from "./RequestCycle/configureCycle";
import Shift from "./Shift";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const goTo = (path) => {
      this.props.history.push(path);
    };
    const { classes, match } = this.props;
    return (
      <Switch>
        <Route path={`${match.path}/policy`} render={(props) => <Policy {...props} goTo={goTo} />} />
        <Route path={`${match.path}/extra_time`} render={(props) => <ExtraTime {...props} goTo={goTo} />} />
        <Route path={`${match.path}/shift`} render={(props) => <Shift {...props} goTo={goTo} />} />
        <Route path={`${match.path}/clockin_method`} render={(props) => <Device {...props} goTo={goTo} />} />
        <Route path={`${match.path}/request_cycle`} render={(props) => <ConfigureCycle {...props} goTo={goTo} />} />
        {/* <Route path={`${match.path}/configurecycle/:requestcycleid`} render={(props) => <ConfigureCycle {...props} goTo={goTo} />} />
                <Route path={`${match.path}/configurecycle`} render={(props) => <ConfigureCycle {...props} goTo={goTo} />} /> */}
        <Route path={`${match.path}`} render={(props) => <AttendanceLog {...props} goTo={goTo} />} />
        <Route path="*" component={PageNotFound} />
      </Switch>
    );
  }
}

index.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(index)));
